import { useSonTranslation } from '../../../../translation/useSonTranslation';
import React from 'react';
import { DescriptedDefinitionList } from '../../../../_lib/components/DefinitionList';
import { AccessLevelData } from '../types';
import { formatDate, TimeFormats } from '../../../../lib/DateFormat';

type DataLabels = {
  mandateName: string;
  mandateEnd: string;
  mandateAdministration: string;
  mandateContactPersonEmail: string;
  officeName: string;
  officeOrgunitHeadEmail: string;
  officeStreet: string;
  officePostcode: string;
  officeLocation: string;
};

type AccessLevelInformationProps = {
  accessLevelDetails: AccessLevelData;
};

export function AccessLevelInformation({ accessLevelDetails }: AccessLevelInformationProps) {
  const { t } = useSonTranslation('AccessLevel');

  const dataForRequestFields: Array<keyof DataLabels> = [
    'mandateName',
    'mandateEnd',
    'mandateAdministration',
    'mandateContactPersonEmail',
  ];
  const jobRelatedDataFields: Array<keyof DataLabels> = [
    'officeName',
    'officeOrgunitHeadEmail',
    'officeStreet',
    'officePostcode',
    'officeLocation',
  ];

  const createTerm = (field: keyof DataLabels, value: any) => {
    return {
      term: t(`dataLabels.${field}`),
      extendedInfoSVG: undefined,
      description: field === 'mandateEnd' ? formatDate(value, TimeFormats.DAY_MONTH_YEAR) : value,
      href: undefined,
    };
  };

  const mapRequestToTerms = (request: AccessLevelData, fields: Array<keyof DataLabels>) => {
    return fields
      .map(field => createTerm(field, request[field]))
      .filter(term => term.description !== undefined && term.description !== null);
  };

  const dataForRequestTerms = mapRequestToTerms(accessLevelDetails, dataForRequestFields);
  const jobRelatedDataTerms = mapRequestToTerms(accessLevelDetails, jobRelatedDataFields);

  return (
    <>
      {dataForRequestTerms.length > 0 ? (
        <DescriptedDefinitionList
          definitionTerms={dataForRequestTerms}
          headline={t('labels.dataForRequestLabel')}
          headlineHierarchy={4}
          styling="no-border-bottom"
        />
      ) : null}
      {jobRelatedDataTerms.length > 0 ? (
        <DescriptedDefinitionList
          definitionTerms={jobRelatedDataTerms}
          headline={t('labels.jobRelatedDataLabel')}
          headlineHierarchy={4}
        />
      ) : null}
    </>
  );
}
